import React, { useEffect, useState } from 'react';
import Loading from '../../../../../components/common/Loading';
import { Bar } from 'react-chartjs-2';
import ORBApi from '../../../../../services/ORBApi';
import { GraphColors } from './GraphOptions';

export default function TracksContributorRevenueGraph({ filters, currency }) {
	const [contributor, setContributor] = useState([]);
	const [setFullNames] = useState([]);
	const [valueContributor, setValueContributor] = useState([]);
	const [fileProcessing, setFileProcessing] = useState(0);
	const [requestSource, setRequestSource] = useState(null);

	const doSearch = () => {
		if (fileProcessing) {
			// if there is a request processing, cancel it
			ORBApi.abortRequest(requestSource);
		}
		setFileProcessing(1);
		var cancelRequestSource = ORBApi.getRequestAbortSource();
		setRequestSource(cancelRequestSource);
		ORBApi.loadTrackContributorRevenue(
			filters.startDate,
			filters.endDate,
			filters.dateType,
			filters.trackId,
			filters.contributorId,
			filters.label,
			cancelRequestSource
		)
			.then((data) => {
				setContributor(data.contributors.map((i) => i.contributor));
				setValueContributor(data.contributors.map((i) => i.value));
				setFullNames(data.contributors.map((i) => i.contributor_full));
				setFileProcessing(0);
			})
			.catch((error) => {
				if (!ORBApi.isCancel(error)) {
					// When cancelling the request, do not remove the "loading"
					setFileProcessing(0);
				}
			});
	};

	useEffect(() => {
		doSearch();
	}, [filters]);

	return (
		<div>
			{fileProcessing ? (
				<Loading className='file-loading-container' />
			) : (
				<Bar
					data={{
						labels: contributor,
						datasets: [
							{
								data: valueContributor,
								backgroundColor: GraphColors,
							},
						],
					}}
					options={{
						plugins: {
							legend: {
								display: false,
							},
							tooltip: {
								callbacks: {
									label: function (context) {
										return context.parsed.y.toLocaleString(
											'pt-br',
											{
												style: 'currency',
												currency: currency,
											}
										);
									},
								},
							},
						},
						scales: {
							y: {
								beginAtZero: true,
								ticks: {
									callback: function (value) {
										return value.toLocaleString(
											'pt-br',
											{
												style: 'currency',
												currency: currency,
											}
										);
									},
								},
							},
						},
					}}
				/>
			)}
		</div>
	);
}
